var map = {
	"./35mm.jpg": 2160,
	"./bdsm.png": 9536,
	"./bulletrain.png": 780,
	"./constellations.png": 3798,
	"./constellations_steam.png": 1099,
	"./drift.png": 4437,
	"./flipnseas.png": 101,
	"./frankdrake.jpg": 8221,
	"./fyre.png": 9194,
	"./gab.png": 3546,
	"./herosjourney.png": 8559,
	"./lok.jpg": 4038,
	"./mercilessgods.png": 422,
	"./moonlight1.png": 7536,
	"./moonlight2.png": 9291,
	"./moonlight3.gif": 4689,
	"./orbital.gif": 8204,
	"./parts.png": 9954,
	"./platformermaintenance.png": 2513,
	"./quanticcat.png": 6665,
	"./retrorift.png": 8189,
	"./rook.png": 1085,
	"./scarletcypress.gif": 50,
	"./sliced.png": 9840,
	"./sneks.png": 5166,
	"./spellfight.png": 7322,
	"./sunlight.png": 6656,
	"./tcyd.png": 7370,
	"./terracotta.jpg": 5199,
	"./terracotta_steam.png": 5998,
	"./tinychess.png": 618,
	"./tinytarot.png": 1074,
	"./titan.png": 2338,
	"./treegolf.png": 3394,
	"./windmillpiano.png": 3727,
	"./witchsupport.png": 7868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8527;